import { graphql } from "react-relay";
import { FeedScheduler } from "@components/feed-scheduler";

export const fragments = {
  viewer: graphql`
    fragment ChromeFeed_viewer on Viewer {
      user {
        givenName
        createdTime
        chromeExtensionFlagsErrorable {
          __typename
          ... on GraphEntityError {
            statusCode
            message
          }
          ... on Flags {
            flags
          }
        }
        flowStates(first: 1000000) {
          edges {
            node {
              ...FastCrawlLoader_flowState
              flowKey
              current {
                state
                percentComplete
                errorMessage
              }
              pending {
                state
                percentComplete
                errorMessage
              }
            }
          }
        }
        orgs(first: 1000000) {
          edges {
            node {
              id
              ...FeedScheduler_org
              orgMeetingHours {
                workingHours {
                  timeZone
                }
              }
              experiments
              primaryTeam {
                __typename
                ... on Team {
                  teamId
                  teamName
                }
                ... on GraphEntityError {
                  statusCode
                  message
                }
              }
              settings(first: 1000000) {
                edges {
                  node {
                    id
                    key {
                      id
                      name
                      scope {
                        id
                        type
                        value
                      }
                      target {
                        id
                        type
                        value
                      }
                    }
                    type {
                      id
                      valueType
                      containerType
                      required
                    }
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
};
